module.exports = __webpack_public_path__ + "static/media/trial3_4.977e52a5.png";